// Store para mantener el estado del proceso de solicitud de envío
export default {
  namespaced: true,
  
  state: {
    // Paso 1: Información del paquete
    package: {
      name: '',
      contents_description: '',
      package_type: 'standard',
      weight: null,
      length: null,
      width: null,
      height: null,
      declared_value: null,
      insurance_required: false,
      special_handling: ''
    },
    
    // Paso 2: Ruta
    route: {
      origin: '',
      destination: '',
      is_local: false
    },
    
    // Paso 3: Servicio y tarifa
    service: {
      service_type: 'envio_normal', // envio_normal o envio_urgente
      weight_category: 'ligero', // ligero, medio, pesado
      selected_tariff: null,
      price: 0
    },
    
    // Paso 4: Direcciones y horario
    addresses: {
      origin_address: '',
      origin_lat: null,
      origin_lng: null,
      origin_date: '',
      origin_time_slot: '',
      destination_address: '',
      destination_lat: null,
      destination_lng: null,
      destination_time_slot: '',
      recipient_name: '',
      recipient_phone: ''
    },
    
    // Paso 5: Resumen
    summary: {
      total_price: 0,
      additional_charges: []
    },
    
    // Control de navegación
    currentStep: 1,
    maxStepReached: 1
  },
  
  mutations: {
    SET_PACKAGE(state, packageData) {
      state.package = { ...state.package, ...packageData };
    },
    
    SET_ROUTE(state, routeData) {
      state.route = { ...state.route, ...routeData };
    },
    
    SET_SERVICE(state, serviceData) {
      state.service = { ...state.service, ...serviceData };
    },
    
    SET_ADDRESSES(state, addressData) {
      state.addresses = { ...state.addresses, ...addressData };
    },
    
    SET_SUMMARY(state, summaryData) {
      state.summary = { ...state.summary, ...summaryData };
    },
    
    SET_CURRENT_STEP(state, step) {
      state.currentStep = step;
      if (step > state.maxStepReached) {
        state.maxStepReached = step;
      }
    },
    
    RESET_REQUEST(state) {
      state.package = {
        name: '',
        contents_description: '',
        package_type: 'standard',
        weight: null,
        length: null,
        width: null,
        height: null,
        declared_value: null,
        insurance_required: false,
        special_handling: ''
      };
      state.route = { origin: '', destination: '', is_local: false };
      state.service = { service_type: 'envio_normal', weight_category: 'ligero', selected_tariff: null, price: 0 };
      state.addresses = {
        origin_address: '',
        origin_lat: null,
        origin_lng: null,
        origin_date: '',
        origin_time_slot: '',
        destination_address: '',
        destination_lat: null,
        destination_lng: null,
        destination_time_slot: '',
        recipient_name: '',
        recipient_phone: ''
      };
      state.summary = { total_price: 0, additional_charges: [] };
      state.currentStep = 1;
      state.maxStepReached = 1;
    }
  },
  
  actions: {
    updatePackage({ commit }, packageData) {
      commit('SET_PACKAGE', packageData);
    },
    
    updateRoute({ commit }, routeData) {
      commit('SET_ROUTE', routeData);
    },
    
    updateService({ commit }, serviceData) {
      commit('SET_SERVICE', serviceData);
    },
    
    updateAddresses({ commit }, addressData) {
      commit('SET_ADDRESSES', addressData);
    },
    
    updateSummary({ commit }, summaryData) {
      commit('SET_SUMMARY', summaryData);
    },
    
    goToStep({ commit }, step) {
      commit('SET_CURRENT_STEP', step);
    },
    
    nextStep({ state, commit }) {
      if (state.currentStep < 5) {
        commit('SET_CURRENT_STEP', state.currentStep + 1);
      }
    },
    
    previousStep({ state, commit }) {
      if (state.currentStep > 1) {
        commit('SET_CURRENT_STEP', state.currentStep - 1);
      }
    },
    
    resetRequest({ commit }) {
      commit('RESET_REQUEST');
    }
  },
  
  getters: {
    canGoToStep: (state) => (step) => {
      return step <= state.maxStepReached + 1;
    },
    
    isStepComplete: (state) => (step) => {
      switch(step) {
        case 1:
          return state.package.name && state.package.weight;
        case 2:
          return state.route.origin && (state.route.is_local || state.route.destination);
        case 3:
          return state.service.selected_tariff !== null;
        case 4:
          return state.addresses.origin_address && state.addresses.destination_address;
        case 5:
          return state.summary.total_price > 0;
        default:
          return false;
      }
    }
  }
};

